import React, { useEffect, useState } from 'react';
import MultiText from '../components/MultiText';
import { Button, Col, Form, Input, message, Modal, Row } from 'antd';
import { CodeOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import RoutePage from '../components/RoutePage';
import liracrypt from '../components/Liracrypt/liracrypt';
import queryString from 'query-string';
import { useSelector } from 'react-redux';
import noImg from '../assets/static/noImg.jpeg';

import { useLocation } from 'react-router-dom';
import ApiErrorComp from '../components/ApiErrorComp/ApiErrorComp';
import { createRoute } from '../utils/CustomFunc';
import ZenModal from '../components/ZenModal';
import MultiLineTypingEffect from '../components/TypeWriter';
const NewPage = ({ setPageHeader }) => {
    const [form] = Form.useForm();
    const { search } = useLocation();
    const searchParams = queryString.parse(search);
    const urlCode = useSelector(state => state.urlCode);
    const [zenModal, setZenModal] = useState();
    const [modal, setModal] = useState({
        // type: props.config.zenModal.typ,
        type: "kanban",
        data: undefined,
        show: false,
        loading: false,
    });
    const toggleModal = ({ show = false, data = undefined, type = type, loading = false }) => {
        setModal({ show, data, type, loading });
    }

    const zenPopupAction = (zenPopup, value, record) => {
        let urlData = { ...zenPopup.params };
        if (zenPopup?.props) {
            urlData[zenPopup?.props] = value;
        }
        if (zenPopup?.multiProps) {
            zenPopup?.multiProps.forEach((prop) => {
                urlData[prop] = record[prop];
            });
        }
        if (zenPopup?.typ === 'smodal') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    id: value,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        };
        if (zenPopup?.typ === 'route') {
            toggleModal({
                loading: false,
                show: true,
                data: {
                    route: zenPopup?.route,
                    urlData
                },
                type: zenPopup?.typ
            });
            return;
        }
        if (zenPopup?.api) {
            toggleModal({ show: true, loading: true, type: zenPopup?.typ });
            liracrypt.get(`${zenPopup?.api}`, urlData).then(response => {
                toggleModal({
                    show: true,
                    data: (zenPopup?.typ === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
                    loading: false,
                    type: zenPopup?.typ
                })
            });
            return;
        }
    }

    const onConfirmation = ({ popData, urlData = {}, resolve, reject }) => {
        if (popData.method === 'GET') {
            liracrypt.get(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'POST') {
            liracrypt.post(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    console.log(err);
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
        if (popData.method === 'PATCH') {
            liracrypt.patch(popData?.api, urlData)
                .then(response => {
                    message.success(response.data.message || 'Successfull');
                    // if (popData?.editDoc) {
                    //     let data = [...tblConfig.data];
                    //     let updateIndex = data.findIndex(x => x._id === response.data.data._id);
                    //     data[updateIndex] = response.data.data
                    //     setTblConfig({
                    //         ...tblConfig,
                    //         data
                    //     })
                    // }
                    resolve();
                }).catch(err => {
                    ApiErrorComp('Oops Something went wrong');
                    reject();
                })
        }
    }

    const onColumnClick = (record, indx) => {
        console.log(indx);
        let __result = [...resultList];
        __result[indx].showResponse = [];
        __result = __result.filter((_, i) => i <= indx);
        // setTimeout(() => {
        //     console.log(resultList);
        // }, 1000);
        if (record.zenPop) {
            let zenPopDataIndex = { ...record.zenPop };
            setZenModal(zenPopDataIndex);
            if (zenPopDataIndex?.typ === 'newTab') {
                let zenParams = { ...zenPopDataIndex.params };
                if (zenPopDataIndex?.api) {
                    zenParams.api = zenPopDataIndex?.api;
                }
                let route = createRoute({
                    props: zenPopDataIndex?.props,
                    record,
                    multiProps: zenPopDataIndex?.multiProps,
                    params: { ...zenParams },
                    urlCode,
                    route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
                });
                window.open(route, '_blank')
                return;
            };

            if (zenPopDataIndex?.typ === 'confirmationPopUp') {
                let urlData = { ...zenPopDataIndex?.onOk?.params };
                if (zenPopDataIndex?.onOk?.multiProps) {
                    zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
                        urlData[prop] = record[prop];
                    });
                };
                if (zenPopDataIndex?.onOk?.props) {
                    urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
                }

                Modal.confirm({
                    title: zenPopDataIndex?.text,
                    okText: zenPopDataIndex?.okButtonText,
                    cancelText: zenPopDataIndex?.cancelButtonText,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            onConfirmation({
                                popData: zenPopDataIndex?.onOk,
                                resolve,
                                reject,
                                urlData
                            });
                        }).catch(() => console.log('Oops errors!'));
                    }
                });
                return;
            }
            zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)
        } else {
            onButtonClick({ btnData: record, index: indx, result: __result });
        }
    }

    if (setPageHeader) {
        setPageHeader('New Page')
    }

    const [resultList, setResultList] = useState([]);
    const __data = {
        "multiText": {
            data: [
                {
                    colSize: 24,
                    text: "Hello Krishan,",
                    style: {
                        fontSize: 14,
                        fontWeight: "bold",
                        color: "#000000"
                    }
                },
                {
                    colSize: 24,
                    text: "How would you like to start the briefing",
                    style: {
                        fontSize: 14,
                        fontWeight: "bold",
                        color: "#000000"
                    }
                },
            ]
        },
        buttons: [
            {
                icon: "EyeOutlined", text: "Plant Summary", style: {
                    backgroundColor: "#9c9c9c",
                    color: "#ffffff",
                    borderRadius: 5
                },
                route: "/dc",
                params: {
                    dn: 'test'
                }
            },
            {
                icon: "EyeOutlined", text: "OLE", style: {
                    backgroundColor: "#1777ff",
                    borderRadius: 5,
                    color: "#ffffff"
                }, route: "/dc",
                params: {
                    dn: 'test'
                }
            },
            {
                icon: "EyeOutlined", text: "Availability", style: {
                    backgroundColor: "#9c9c9c",
                    borderRadius: 5,
                    color: "#ffffff"
                }, route: "/dc",
                params: {
                    dn: 'test'
                }
            },
            {
                icon: "EyeOutlined", text: "Pierce", style: {
                    backgroundColor: "#1777ff",
                    borderRadius: 5,
                    color: "#ffffff"
                }, route: "/dc",
                params: {
                    dn: 'test'
                }
            },
        ]
    };

    const onButtonClick = ({ btnData, index, result = [] }) => {
        // liracrypt.get('/test', { dn: 'SparkTableWithDefault' })
        //     .then(({ data }) => {
        //         if (data.isSuccess) {

        //         }
        //     })
        let _result = result || [...resultList];
        _result[index].showResponse = [
            {
                route: '/dc',
                params: { "dn": 'test' },
                height: 100
            },
            {
                route: '/lineperformance',
                params: { a: 'b' },
                height: 100
            }
        ];
        console.log(_result);
        setResultList([..._result, __data]);
        setTimeout(() => {
            const element = document.getElementById(`route-page-${resultList.length - 1}`);
            if(element){
                element.scrollIntoView({ behavior: "smooth" });
            }
        }, 300);
    }

    useEffect(() => {
        liracrypt.get('/textapi', { dn: 'SparkTableWithDefault' })
            .then(({ data }) => {
                if (data.isSuccess) {
                    setResultList([{ ...__data, showResponse: null }]);
                }
            })
    }, []);


    useEffect(() => {
        const handleScroll = () => {
            let scrollBtn = document.getElementById("scrollBtn");
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                scrollBtn.style.display = "block";
            } else {
                scrollBtn.style.display = "none";
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const scrollTop = () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    return (
        <div style={{ backgroundColor: '#e4deed' }}>
            <div className='container' style={{ padding: 10 }}>
                <ZenModal modal={modal} toggleModal={toggleModal} zenModal={zenModal} />
                {
                    resultList.map((x, indx) => (
                        <>
                            <div className='card' style={{ backgroundColor: '#e4deed', marginBottom: 20, borderRadius: 10, padding: 10, boxShadow: '-1px 1px 1px 1px #2b144d' }}>
                                <Row>
                                    <Col span={18} style={{ padding: 20 }}>
                                        <div className='animate__animated animate__bounceInLeft' style={{ border: '1px solid #2b144d', padding: 10, marginBottom: 10, borderRadius: 10, margin: 'auto' }}>
                                            {/* <MultiText data={x.multiText.data} /> */}
                                            <MultiLineTypingEffect />
                                        </div>
                                        <div className='animate__animated animate__shakeX animate__delay-2s' style={{ marginTop: 20 }}>
                                            <div
                                                className="AuditSection CreateAudit"
                                            >
                                                <div className="ThemeForm">
                                                    <Form
                                                        labelWrap={true}
                                                        name={"GPTQueryForm-" + indx}
                                                        form={form}
                                                        wrapperCol={{ span: 24 }}
                                                        layout="horizontal"
                                                        colon={false}
                                                        onFinish={() => onColumnClick({}, indx)}
                                                        size="large"
                                                    >
                                                        <Row justify={"center"}>
                                                            <div style={{ width: '100%' }} className='prompt-wrapper'>
                                                                <Form.Item name={"prompt-" + indx} rules={[
                                                                    { required: true },
                                                                ]}>
                                                                    <Input className='prompt-input' type="text" placeholder='Enter your prompt' />
                                                                </Form.Item>
                                                            </div>
                                                        </Row>

                                                    </Form>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col span={6} style={{ padding: 20 }}>
                                        <div className='animate__animated animate__flipInX animate__delay-0.2s' style={{ width: '100%' }}>
                                            {
                                                x.buttons.map((x, i) => (
                                                    <Button className={`animate__animated animate__backInDown animate__delay-${i}s`} onClick={() => onColumnClick(x, indx)} style={{ width: '100%', marginRight: 10, marginTop: 10, ...x.style }} icon={<EditOutlined />}>{x.text}</Button>
                                                ))
                                            }
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            {
                                x.showResponse?.length ?
                                    <>
                                        {
                                            x.showResponse.map((x, i) => (
                                                <div id={`route-page-${indx}`} key={`route-page-${i}`} className='card animate__animated animate__fadeInLeftBig' style={{ maxHeight: x.height || 100, overflowY: 'scroll', backgroundColor: '#e4deed', marginBottom: 10, borderRadius: 10, padding: 10, boxShadow: '-1px 1px 1px 1px #2b144d' }}>
                                                    <RoutePage route={x.route} params={{ ...x.params }} />
                                                </div>
                                            ))
                                        }


                                        {/* <div className='card animate__animated animate__fadeInLeftBig' style={{ backgroundColor: '#e4deed', marginBottom: 10, borderRadius: 10, padding: 10, boxShadow: '-1px 1px 1px 1px #2b144d' }}>
                                            <RoutePage route="/lineperformance" params={{ a: 'test' }} />
                                        </div> */}
                                    </> : <></>
                            }

                        </>
                    ))
                }

            </div>
            <button onClick={scrollTop} id="scrollBtn" title="Go to top">Top</button>
        </div>
    )
};

export default NewPage;